import Api from '@/services/api-service'
import route from '@/router'

export default {
  state: {
    items: [],
    adding: false,
    fetchFavorites: []
  },
  mutations: {
    SET_FAVORITE_ITEM (state, item) {
      state.items.push(item)
    },
    SET_FAVORITE_PRODUCTS (state, products) {
      state.products = products
    },
    REMOVE_FAVORITE_ITEM (state, index) {
      state.items.splice(index, 1)
    },
    REMOVE_FAVORITE_PRODUCT (state, index) {
      state.products.splice(index, 1)
    }
  },
  actions: {
    fetchFavoriteItem ({
      commit,
      state,
      getters
    }, item) {
      var check_item = getters.getFavoriteItem(item)
      if (check_item) {
        var index = state.items.indexOf(item)
        var check_product = getters.getFavoriteProduct(item)
        var product_index = state.items.indexOf(check_product)
        commit('REMOVE_FAVORITE_ITEM', index)
        commit('REMOVE_FAVORITE_PRODUCT', product_index)
      } else {
        commit('SET_FAVORITE_ITEM', item)
      }
    },
    fetchFavorites ({
      commit,
      state,
      getters
    }, item) {
      commit('SET_FAVORITE_PRODUCTS', item)
    }
  },
  getters: {
    getFavoriteItem: state => item_id => {
      return state.items.find(item => item == item_id)
    },
    getFavoriteProduct: state => item_id => {
      return state.products.find(item => item.id == item_id)
    }
  }
}
